import * as types from '../constants'

import API_SHARED from '@api/shared'
import API_FAQ from '@api/faq'
import TOOLS from '@helpers/tools'
import { isEmpty } from 'lodash'

export const updateFaq = payload => ({
  type: types.UPDATE_FAQ,
  payload,
})

export const updateQuestionById = payload => ({
  type: types.UPDATE_FAQ_QUESTION,
  payload,
})

export const updateSimulatorActived = payload => ({
  type: types.UPDATE_SIMULATOR_ACTIVED,
  payload,
})

export const updateCities = payload => ({
  type: types.UPDATE_CITIES,
  payload,
})
export const updatePolicies = payload => ({
  type: types.UPDATE_POLICIES,
  payload,
})
export const updateRegion = payload => ({
  type: types.UPDATE_REGION,
  payload,
})
export const updateSearch = payload => ({
  type: types.UPDATE_SEARCH_IDS,
  payload,
})
export const updateRegionsByCitySimulator = payload => ({
  type: types.UPDATE_REGIONS_BY_CITY_SIMULATOR,
  payload,
})
export const updateRegionsByCitySimple = payload => ({
  type: types.UPDATE_REGIONS_BY_CITY_SIMPLE,
  payload,
})
export const updateBranchesByRegion = payload => ({
  type: types.UPDATE_BRANCHES_BY_REGION,
  payload,
})
export const updateBranchesByCoords = payload => ({
  type: types.UPDATE_BRANCHES_BY_COORDS,
  payload,
})
export const updateBranchesMapSuggest = payload => ({
  type: types.UPDATE_BRANCHES_MAP_SUGGEST,
  payload,
})
export const updatePhone = payload => ({
  type: types.UPDATE_PHONE,
  payload,
})
export const updateRegions = payload => ({
  type: types.UPDATE_REGIONS,
  payload,
})
export const updateSearchItems = payload => ({
  type: types.UPDATE_SEARCH_ITEMS,
  payload,
})

export const getItemsByTermFromSearchBar = (term) => dispatch => {
  const apiCall = (term, grantGeolocation, resolve, reject) => {
    return API_SHARED.getItemsByTermFromSearchBar(term, grantGeolocation)
    .then(response => {
      if (response.success) {
        dispatch(updateSearchItems(response))
      }
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  }

  return new Promise((resolve, reject) => {
    if ('permissions' in navigator) {
      navigator.permissions.query({ name: 'geolocation' }).then(res => {
        const grantGeolocation = res.state === 'granted' ? true : false

        apiCall(term, grantGeolocation, resolve, reject)
      })
    } else {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          success => apiCall(term, true, resolve, reject),
          error => apiCall(term, false, resolve, reject)
        )
      }
    }
  })
}

export const updateSimulatorResult = payload => ({
  type: types.UPDATE_SIMULATOR_RESULT,
  payload,
})

export const simulatorLoading = payload => ({
  type: types.SIMULATOR_LOADING,
  payload,
})

export const updateOptionsModals = (payload) => ({
  type: types.CONTACT_MODALS_OPTIONS,
  payload,
})

export const updatehighlightModal = payload => ({
  type: types.CONTACT_MODALS_HIGHLIGHT,
  payload,
})

export const setIndicateFailureMessage = payload => ({
  type: types.INDICATE_FAIL_MESSAGE,
  payload,
})

export const updateRegionBranches = payload => ({
  type: types.UPDATE_REGION_BRANCHES,
  payload,
})

export const optionsModals = (payload) => (dispatch) => {
  dispatch(updateOptionsModals(payload))
}

export const updateToursModal = (payload) => ({
  type: types.UPDATE_MODAL_TOURS,
  payload,
})

export const updateGalleryModal = (payload) => ({
  type: types.UPDATE_MODAL_GALLERY,
  payload,
})

export const highlightModal = (imovelId, imovelNome, imovelLocalizacao, imovelIdFacilita) => (dispatch) => {
  let highlightModal = {}
  if (imovelId !== '' && imovelNome !== '' && imovelLocalizacao !== '') {
    highlightModal = {
      imovelId: imovelId,
      imovelNome: imovelNome,
      imovelLocalizacao: imovelLocalizacao,
      idFacilita: imovelIdFacilita,
    }
  }
  return dispatch(updatehighlightModal(highlightModal))
}

export const setContactModalsState = (contactModals, modal, state) => (dispatch) => {

  contactModals = {
    ...contactModals,
    [modal]: state,
    modalOpened: state,
  }
  return dispatch(
    {
      type: types.CONTACT_MODALS,
      contactModals,
    }
  )
}

export const setContactModalsStateByObj = (contactModals, obj) => (dispatch) => {

  contactModals = {
    ...contactModals,
    ...obj,
  }
  return dispatch(
    {
      type: types.CONTACT_MODALS,
      contactModals,
    }
  )
}

export const geolocation = () => dispatch => {
  return new Promise(() => {
    API_SHARED.geolocation().then((response) => {
      // 1 => SP | 22 => RJ | 24 => RS
      if (![1, 22, 24].includes(+response.IdEstado)) {
        response.IdEstado = 1
      }
      dispatch(this.switchLocation(response.IdEstado))
    })
  })
}

export const contactMessage = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_SHARED.contactMessage(payload).then((response) => {
      resolve(response)
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const subscribeNewsLetter = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_SHARED.subscribeNewsLetter(payload).then((response) => {
      resolve(response)
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const getQuestions = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_FAQ.getQuestions(payload).then((response) => {
      dispatch(updateFaq(response))
      resolve()
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const getPolicies = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    const policies = {
      privacy: [],
      cookies: [],
    }

    API_SHARED.getPolicies(1).then((response) => {
      policies.privacy = response.topicos
    })
    .catch((error) => {
      reject(error)
    })

    API_SHARED.getPolicies(2).then((response) => {
      policies.cookies = response.topicos
    })
    .catch((error) => {
      reject(error)
    })

    dispatch(updatePolicies(policies))
    resolve()
  })
}


export const getQuestionById = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_FAQ.getQuestionById(payload).then((response) => {
      dispatch(updateQuestionById(response))
      resolve()
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const getCities = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_SHARED.getCities(payload).then((response) => {
      dispatch(updateCities(response))
      resolve()
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const getRegionsByCitySimulator = (idCidade) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_SHARED.getRegionsByCitySimulator(idCidade).then((response) => {
      dispatch(updateRegionsByCitySimulator(response))
      resolve()
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const getRegionsByCitySimple = (idCidade) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_SHARED.getRegionsByCitySimple(idCidade).then((response) => {
      dispatch(updateRegionsByCitySimple(response))
      resolve()
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const getBranchesByCoords = (latitude = false, longitude = false) => (dispatch) => {

  const getBranchesByCoords = (lat, lng, resolve, reject) => {
    return API_SHARED.getBranchesByCoords(lat, lng)
    .then((response) => {
      dispatch(updateBranchesByCoords(response.Filiais))
      dispatch(updateBranchesMapSuggest(response.semCoordenadas))
      resolve()
    })
    .catch((error) => {
      reject(error)
    })
  }

  return new Promise((resolve, reject) => {

    const navigatorSuccess = position => {
      const { coords: { latitude, longitude } } = position
      getBranchesByCoords(latitude, longitude, resolve, reject)
    }
    const navigatorError = () => {
      getBranchesByCoords(0, 0, resolve, reject)
    }

    if (navigator.geolocation && !(latitude && longitude) && (latitude !== 0)) {
      navigator.geolocation.getCurrentPosition(navigatorSuccess, navigatorError)
    } else {
      getBranchesByCoords(latitude, longitude, resolve, reject)
    }
  })
}



export const getBranchesByRegion = (regionId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_SHARED.getBranchesByRegion(regionId)
    .then((response) => {
      dispatch(updateBranchesByCoords(response.Filiais))
      dispatch(updateBranchesMapSuggest(response.sugestao))
      resolve()
    })
    .catch((error) => {
      reject(error)
    })
  })
}

export const getRegions = () => (dispatch) => {
  return API_SHARED.getRegions().then((response) => {
    dispatch(updateRegions(response))
  })
}

export const switchLocation = (region, productId = null) => (dispatch) => {
  if (region) {
    localStorage.setItem('storedRegion', region)
  }

  const integrationTypes = {
    'New-i': 'GuidCrm',
    'Sua house': 'IdSuaHouse',
    'Facilita': 'IdFacilita',
  }

  API_SHARED.getPhoneNumber(region, productId).then((response) => {

    let integrationFounded = { Nome: 'Facilita' }
    if (
      !!response.tiposIntegracoes &&
      !isEmpty(response.tiposIntegracoes) &&
      +response.phone.IdTipoIntegracaoLead
    ) {
      integrationFounded = response.tiposIntegracoes.find(
        integration => +integration.Id === response.phone.IdTipoIntegracaoLead
      )
    }

    const phone = {
      ...response.phone,
      TipoGuidIntegracao: integrationTypes[integrationFounded.Nome],
      TiposIntegracoes: [...response.tiposIntegracoes],
    }

    dispatch(updatePhone(phone))
  })
  dispatch(updateRegion(+region))
}

export const simulatorCalc = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_SHARED.simulatorCalc(payload).then((response) => {
      dispatch(updateSimulatorResult(response))
      resolve(response)
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const indicate = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_SHARED.indicate(payload).then((response) => {
      if (response.success) {
        resolve(response)
      } else if (!response.success) {
        dispatch(setIndicateFailureMessage(response.msg))
      }
    })
      .catch((error) => {
        reject(error)
      })

  })
}

export const contactUsChat = payload => dispatch => {
  return API_SHARED.contactUsChat(payload).then((response) => {
    return response
  })
}

export const contactUsWhatsapp = payload => dispatch => {
  return API_SHARED.contactUsWhatsapp(payload).then((response) => {
    return response
  })
}

export const contactUsCall = payload => dispatch => {
  return API_SHARED.contactUsCall(payload).then((response) => {
    return response
  })
}
export const contactUsNeighbour = payload => dispatch => {
  return API_SHARED.contactUsNeighbour(payload).then((response) => {
    return response
  })
}
export const contactUsWork = payload => dispatch => {
  return API_SHARED.contactUsWork(payload).then((response) => {
    return response
  })
}

export const getRegionBranches = (idEstado, idImovel) => (dispatch) => {
  return new Promise((resolve, reject) => {
    API_SHARED.getRegionBranches(idEstado, idImovel).then((response) => {
      if (response.sucess) {
        navigator.geolocation.getCurrentPosition(geolocation => {
          const coords = geolocation.coords
          const distanceFromLocation = (lat, lon) => TOOLS.calcDistance(coords.latitude, coords.longitude, lat, lon)
          response.listaFiliaisAtendimento.sort((a, b) =>
            distanceFromLocation(a.Latitude, a.Longitude) - distanceFromLocation(b.Latitude, b.Longitude)
          )
          dispatch(updateRegionBranches(response))
        },
        () => {
          dispatch(updateRegionBranches(response))
        })
        resolve()
      }
    })
    .catch((error) => {
      reject(error)
    })
  })
}

export const recordLog = payload => dispatch => {
  return API_SHARED.recordLog(payload).then((response) => {
    return response
  })
}

export const updateLastProductCity = payload => ({
  type: types.UPDATE_LAST_PRODUCT_CITY,
  payload,
})

export const updateShowNewsletter = payload => ({
  type: types.UPDATE_SHOW_NEWSLETTER,
  payload,
})

export const callFacilita = payload => dispatch => {
  return API_SHARED.callFacilita(payload).then((response) => {
    return response
  })
}

export const submitSimuladorForm = payload => dispatch => {
  return API_SHARED.submitSimuladorForm(payload).then((response) => {
    return response
  })
}



// WEBPACK FOOTER //
// ./src/store/shared/actions.js